import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import webSocket from '@/sockets/socket';
class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  update = 'update';
  nearest = 'nearest';
  detail = 'detail';
  exchangeRate = 'exchange-rate';
  getDevices = 'number-device';

  async getDetailRequest(id) {
    let request = {
      url: [this.getAPIUrl(), 'edit', id].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  /**
   * Lấy danh sách chi tiết request theo nhiều request_id (dùng cho multi upgrade/extend)
   * Created by: AI Assistant - 12/03/2026
   */
  async getDetailRequestsBatch(ids) {
    let request = {
      url: [this.getAPIUrl(), 'edit-batch'].join('/'),
      data: ids || [],
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getDetailRequestCompanyCode(companyCode) {
    let request = {
      url: [this.getAPIUrl(), this.detail, companyCode].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  async insertRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: model,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  async updateRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.update].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Lưu nhiều request trong một lần gọi
   * Created by: AI Assistant - 12/03/2026
   */
  async saveBatchRequests(payload) {
    let request = {
      url: [this.getAPIUrl(), 'save-batch'].join('/'),
      data: payload || [],
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Tạo request nhiều chi nhánh: BE tạo 1 parent + N children có parent_id/child_sequence.
   * Dùng cho new-branch — save-batch lưu rời từng request nên view/approve không load lại
   * được children (GET parent/{id}/children rỗng).
   * @param {Array} requests danh sách RequestDtoEdit (payload.model của từng chi nhánh)
   */
  async createMultiBranchSimple(requests) {
    let request = {
      url: [this.getAPIUrl(), 'multi-branch-simple'].join('/'),
      data: requests || [],
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  async deletelRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.deleteAsync(request);

    return res;
  }

  async nearestRequest(companyCode, branchId) {
    let request = {
      url: [this.getAPIUrl(), this.nearest].join('/'),
      params: { companyCode, branchId },
    };
    var res = httpClient.getAsync(request, false);
    return res;
  }

  /**
   * Lấy số lượng thiết bị của domain đã mua
   * @param {string} domain Mã công ty (companyCode)
   * @param {string} key packageUpgradeKey (GUID, có thể rỗng)
   */
  async getDevicesOfDomain(domain, key) {
    let request = {
      url: [this.getAPIUrl(), this.getDevices, domain].join('/'),
      data: JSON.stringify({ packageUpgradeKey: key }),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Tạo multi-branch request cho nhiều chi nhánh
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async createMultiBranchRequest(payload) {
    let request = {
      url: [this.getAPIUrl(), 'multi-branch'].join('/'),
      data: payload,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Lấy chi tiết parent request với children
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getParentRequestDetail(parentId) {
    let request = {
      url: [this.getAPIUrl(), 'parent', parentId].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  /**
   * Lấy danh sách children của parent request
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getRequestChildren(parentId) {
    let request = {
      url: [this.getAPIUrl(), 'parent', parentId, 'children'].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  /**
   * Description: Tạo hoặc cập nhật request theo companyCode thủ công
   * Created by: ndthi
   * Created date: 2024-07-23
   */
  async manualCreateUpdateRequest(companyCode) {
    let request = {
      url: [this.getAPIUrl(), 'manual-create-update-request-auth', companyCode].join('/'),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Cập nhật partner cho danh sách công ty
   * Created by: ndthi
   * Created date: 2024-07-24
   */
  async updatePartnerBatch(payload) {
    let request = {
      url: [this.getAPIUrl(), 'update-partner-batch'].join('/'),
      data: payload,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Gửi email inactive tự động
   * Created by: ndthi
   * Created date: 2025-12-15
   */
  async sendMailInactiveAutomatic() {
    let request = {
      url: [this.getAPIUrl(), 'send-mail-inactive-automatic'].join('/'),
    };
    var res = await httpClient.postAsync(request);
    return res;
  }

  /**
   * Description: Chạy job Auto Renew thủ công — không chờ cron 1h sáng
   * @param {object} payload { companyCodes: "ABC;XYZ" (danh sách ';' — bỏ trống/null = tất cả, giữ filter auto_renew=1 + WL/us),
   *                           refDate: "yyyy-MM-dd" (ngày référence để test — null = hôm nay) }
   * Created by: lvduy
   * Created date: 2026-08-17 (params companyCodes/refDate 2026-08-24)
   */
  async autoRenew(payload) {
    let request = {
      url: [this.getAPIUrl(), 'auto-renew'].join('/'),
      data: payload || {},
    };
    var res = await httpClient.postAsync(request);
    return res;
  }
  async getVCBExchangeRate() {
    let request = {
      url: [this.getAPIUrl(), this.exchangeRate].join('/'),
    };
    var res = await httpClient.getAsync(request, false);
    return res;
  }

  async getLicenseSuman(applicationUrl, loading = true) {
    const request = {
      url: [this.getAPIUrl(), `license-suman?applicationUrl=${applicationUrl}`].join('/'),
    };
    return httpClient.getAsync(request, loading);
  }

  async getLicenseSumanByCompanyCodes(companyCodes, loading = true) {
    const request = {
      url: [this.getAPIUrl(), `license-suman-batch?companyCodes=${encodeURIComponent(companyCodes.join(','))}`].join('/'),
    };
    return httpClient.getAsync(request, loading);
  }
}

export default new RequestAPI();
